import { render, staticRenderFns } from "./UploadedLabels.vue?vue&type=template&id=22a87b70&"
import script from "./UploadedLabels.vue?vue&type=script&lang=js&"
export * from "./UploadedLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports